import React from "react"

function TextImage(props) {
  const { content } = props

  return (
    <div className="section-text-image">
     <div className="container">
       <div className="text-image-wrapper">
        <div className="text-holder">
          <h2 className="title"> { content.title }</h2>
        </div>
        <div className="image-holder">
          <img src={ content.image } className="image img-fluid" alt= { content.name } />
        </div>
       </div>
     </div>
    </div>
  )
}

export default TextImage